import { render } from "./AppVersion.vue?vue&type=template&id=1bb279aa&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"

import "./AppVersion.vue?vue&type=style&index=0&id=1bb279aa&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb279aa"]])

export default __exports__